export enum EntityType {    
    Donor = 1,
    Recipient = 2,
    OneWay = 3,
    Center = 4,
    Invoice = 5,
    XmTracking = 6,
    Rexm = 7,
    SerologyTracking = 8,
    Rccap = 9,
    DcnDonorRegistration = 10,
    Cluster = 11
}